module.exports = __webpack_public_path__ + "img/peru.90dba0d.webp";